import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventTypeBgcolor',
})
export class EventTypeBgcolorPipePipe implements PipeTransform {
  eventType: string = '';

  transform(value: unknown, ..._args: unknown[]): string {
    switch (value) {
      case 1110: {
        return '#2CBDF0';
      }
    }
    return '#B7EB8F';
  }
}
